$(() => {
  globalThis.focusSelect2Fields = function () {
    $(".select2").each(function () {
      if ($(this).hasClass("select2-hidden-accessible")) {
        $(this).select2("open");
        setTimeout(function () {
          const searchField = $(".select2-search__field")[0];
          if (searchField) {
            searchField.focus();
          }
        }, 10);
      }
    });
  };

  $(".select2").select2({
    tags: true,
    tokenSeparators: [",", " "],
    dropdownAutoWidth: true,
    dropdownParent: $("body"),
  });

  $(document).on("select2:open", ".select2", function (e) {
    const openedSelect = $(this);
    setTimeout(function () {
      const container = openedSelect.next(".select2-container");
      const searchField =
        container.find(".select2-search__field")[0] ||
        $(".select2-dropdown:visible .select2-search__field").last()[0];
      if (searchField) {
        searchField.focus();
      }
    }, 10);
  });

  $(document).on("click", ".select2-selection", function (e) {
    const selectElement = $(this).closest(".select2-container").prev("select");
    if (selectElement.hasClass("select2")) {
      setTimeout(function () {
        const container = selectElement.next(".select2-container");
        const searchField =
          container.find(".select2-search__field")[0] ||
          $(".select2-dropdown:visible .select2-search__field").last()[0];
        if (searchField) {
          searchField.focus();
        }
      }, 50);
    }
  });
});
